import React, { useState, useEffect, createContext, useContext } from 'react';
import WPApiFetch from '../Utility/WPApi'

export const ThemeOptionsContext = createContext();

export default function ThemeOptionsProvider({children}) {
	const [options, setOptions] = useState(null);
	useEffect(() => {
	    async function fetchOptions() {
			const data =  await WPApiFetch('/acf/v3/options/options');
			setOptions( data );
	    }
	    fetchOptions();
	}, [])
	return <ThemeOptionsContext.Provider value={options}>{children}</ThemeOptionsContext.Provider>
}

export function useThemeOptions() {
	const context = useContext(ThemeOptionsContext);
	if (context === undefined) {
		throw new Error("Context must be used within a Provider");
	}
	return context;
}